import { RouteModel, SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { GUID_, guids } from '@appShared/guids'

const baseUri = window.location.origin /* https://southwestern-dealertraining-web-portal-test-as.azurewebsites.net */

export const environment = {
   production: false,
   apiConfig: {
      authorityDomain: 'testauth.advantage4dealers.com',
      endpointUri: `${baseUri}/api`,
      msalConfig: {
         auth: {
            /* guids below used to obfuscate the clientId in PROD */
            [guids.get(GUID_.B8C119E38553467B8ED361CB1AC821C5)]: 'b16aedc9-1513-491b-8190-ed3fb54443cf'
         }
      },
      piiLoggingEnabled: true,
      scopes: [
         'https://swfcb2c.onmicrosoft.com/swfc-learning-portal-web-api/test.subscription.manage',
         'https://swfcb2c.onmicrosoft.com/swfc-learning-portal-web-api/test.content.subscribed'
      ],
      userFlows: {
         defaultSignIn: 'B2C_1_A4D_SI_v1_test',
         usernameSignIn: 'B2C_1_A4D_SI_Username_v1_test',
         workAccountSignUpSignIn: 'B2C_1_A4D_SUSI_Fed_v1_test'
      }
   },
   appStore: {
      apple: 'https://apps.apple.com/us/app/southwestern-lead/id6478800540 ',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.southwestern.lead'
   },
   baseUri,
   brightcove: {
      accountId: 753829919001,
      experiences: {
         dashboard: '66c4f79abf6b4422547345ec',
         faq: '661436a3fd8b4685703d56bf',
         meetTheMentorsUrl: 'https://site-28869320.bcvp0rtal.com/',
         addedValuePortalUrl: 'https://site-56995380.bcvp0rtal.com'
      },
      playerId: 'KrH874wOd'
   },
   dealerApiUri: 'https://testportal.advantage4dealers.com/api/dealer',
   playerUri: 'player',
   publicCdn: {
      uri: 'https://swfclearningprod.blob.core.windows.net/dealer-training',
      areaImagesFolder: 'area-images',
      courseImagesFolder: 'course-images',
      dashboardImagesFolder: 'dashboard-images',
      resourceImagesFolder: 'resource-images',
      badgeImagesFolder: 'badge-images'
   },
   internalUris: {
      academic_resources: {
         title: 'Academic Resources',
         uri: 'https://test.advantage4teens.com',
      } as RouteModel,
      sales_portal: {
         title: 'Advantage4Dealers',
         uri: 'https://test.advantage4dealers.com'
      } as RouteModel
   },
   routes: SITE_DIRECTORY_ROUTES,
   userPrincipalIdHeaderName: 'UserPrincipalId-29239E59E0924FC4',
   /* guids below used to obfuscate in PROD */
   [GUID_.E567D0E4603F4A7580212E770DE079AA]: '1204683634232208',                 //serviceLayerClientId
   [GUID_.D9A8BADB30FA4EDE975EAE987AABFBD4]: 'e91ee2fd0f634a28aa43e0223c3864bf'  //serviceLayerClientSecret
}
